<template>
    <tr>
        <td>
            <div class="content-element">
                <div v-for="i in deep" class="spacer"></div>
                <template v-if="item.type === 2">
                    <div v-if="item.openned !== true" class="content-element__opener"  v-on:click="openDir(item)">
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.75L7 7L1 12.25" stroke="#4D4D4D" stroke-width="2"
                                  stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div v-else class="content-element__opener is-open"  v-on:click="closeDir(item)">
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.75L7 7L1 12.25" stroke="#4D4D4D" stroke-width="2"
                                  stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </template>
                <div v-if="item.type === 2" class="content-element__file">
                    <svg width="17" height="14" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.402 2.767h-7.18L5.876.544A.164.164 0 005.766.5H.682a.636.636 0 00-.64.634v11.732c0 .35.286.634.64.634h14.72c.355 0 .64-.283.64-.634V3.4a.636.636 0 00-.64-.634z"
                            fill="currentColor" />
                    </svg>
                    <span>{{item.title}}</span>
                </div>
                <div v-if="item.type === 1" class="content-element__file">
                    <svg v-if="item.type_id === 2" width="14" height="14" viewBox="0 0 14 14" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.25 0.777778V1.55556H10.5V0.777778C10.5 0.35 10.1062 0 9.625 0H4.375C3.89375 0 3.5 0.35 3.5 0.777778V1.55556H1.75V0.777778C1.75 0.35 1.35625 0 0.875 0C0.39375 0 0 0.35 0 0.777778V13.2222C0 13.65 0.39375 14 0.875 14C1.35625 14 1.75 13.65 1.75 13.2222V12.4444H3.5V13.2222C3.5 13.65 3.89375 14 4.375 14H9.625C10.1062 14 10.5 13.65 10.5 13.2222V12.4444H12.25V13.2222C12.25 13.65 12.6438 14 13.125 14C13.6062 14 14 13.65 14 13.2222V0.777778C14 0.35 13.6062 0 13.125 0C12.6438 0 12.25 0.35 12.25 0.777778ZM3.5 10.8889H1.75V9.33333H3.5V10.8889ZM3.5 7.77778H1.75V6.22222H3.5V7.77778ZM3.5 4.66667H1.75V3.11111H3.5V4.66667ZM12.25 10.8889H10.5V9.33333H12.25V10.8889ZM12.25 7.77778H10.5V6.22222H12.25V7.77778ZM12.25 4.66667H10.5V3.11111H12.25V4.66667Z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 2.85714C0 2.09938 0.302901 1.37266 0.842068 0.836838C1.38124 0.30102 2.1125 0 2.875 0H20.125C20.8875 0 21.6188 0.30102 22.1579 0.836838C22.6971 1.37266 23 2.09938 23 2.85714V17.1429C23 17.9006 22.6971 18.6273 22.1579 19.1632C21.6188 19.699 20.8875 20 20.125 20H2.875C2.1125 20 1.38124 19.699 0.842068 19.1632C0.302901 18.6273 0 17.9006 0 17.1429V2.85714ZM1.4375 15.7143V17.1429C1.4375 17.5217 1.58895 17.8851 1.85853 18.153C2.12812 18.4209 2.49375 18.5714 2.875 18.5714H20.125C20.5062 18.5714 20.8719 18.4209 21.1415 18.153C21.411 17.8851 21.5625 17.5217 21.5625 17.1429V12.1429L16.1331 9.36143C15.9983 9.29432 15.8456 9.27104 15.6968 9.29488C15.5479 9.31872 15.4104 9.38848 15.3036 9.49429L9.9705 14.7943L6.14675 12.2629C6.00869 12.1715 5.8431 12.1304 5.67804 12.1466C5.51298 12.1627 5.35862 12.2351 5.24113 12.3514L1.4375 15.7143ZM8.625 6.42857C8.625 5.86025 8.39782 5.31521 7.99345 4.91334C7.58907 4.51148 7.04062 4.28571 6.46875 4.28571C5.89688 4.28571 5.34843 4.51148 4.94405 4.91334C4.53968 5.31521 4.3125 5.86025 4.3125 6.42857C4.3125 6.99689 4.53968 7.54194 4.94405 7.9438C5.34843 8.34566 5.89688 8.57143 6.46875 8.57143C7.04062 8.57143 7.58907 8.34566 7.99345 7.9438C8.39782 7.54194 8.625 6.99689 8.625 6.42857Z" fill="currentColor"/>
                    </svg>
                    <span>{{item.name}}</span>
                </div>
            </div>
        </td>
        <td v-if="item.type === 2">
            -
        </td>
        <td v-if="item.type === 1">
            {{item.duration}}
        </td>
        <td>
            <div class="form-check"><input class="form-check-input" type="radio" name="content_radio" :value="item" v-model="picked"></div>
        </td>
    </tr>
    <report-create-content-row-element v-if="item.openned === true" v-for="row in item.content" @pickItem="pickItem" @openDir="openDir" :item="row" :deep="this.deep + 1"></report-create-content-row-element>
</template>

<script>
export default {
    name: "ReportCreateContentRowElement",
    props: {
        item: Object,
        deep: Number
    },
    data: function () {
        return {
            picked: false
        }
    },
    emits: [
        'openDir',
        'pickItem'
    ],
    watch: {
        picked() {
            this.pickItem(this.item);
        }
    },
    methods: {
        pickItem: function (item) {
            this.$emit('pickItem', item);
        },
        openDir: function (item) {
            this.$emit('openDir', item);
            item.openned = true;
        },
        closeDir: function (item) {
            item.openned = false;
        },
    }
}
</script>

<style scoped>

</style>
